import { CityType } from 'shared/api/addressType';
import { FileDescriptor } from './fileTypes';
import { AuthorDescription } from './postTypes';

export enum SectionEnum {
  all = 'all',
  post = 'post',
  publication = 'publication',
  people = 'people',
}

export type SearchItemAuthors = {
  contacts: {
    contact: string;
    objId: number;
  }[];
  fioShort: string;
  firstName: string;
  middleName: string;
  lastName: string;
  objId: number;
  uref: string;
};

export enum SearchItemTypeEnum {
  post = '302',
  onlyPost = '302.0',
  onlyRepost = '302.1',
  publication = '205',
  people = '202',
}

export type SearchItemEntityInfo = {
  rEntity: string;
  fullName: string;
  imageUrl: string | null;
  subscribed: boolean | null;
};

type SearchItemBase = {
  authorInfo?: AuthorDescription[];
  id?: string;
  dsc?: string | null;
  title?: string;
  annotation?: string;
  keywords?: string | null;
  keywordsArr?: string[];
  place?: string;
  publicationDate?: string;
  year?: number;
  previewUrl?: string | null;
  authors?: SearchItemAuthors[] | null;
  files?: FileDescriptor[];
  feedId?: string;
  feedInfo?: {
    feedId: string;
    feedItemId: string;
    feedTitle: string;
  };
  feedOwnerInfo?: AuthorDescription;
  upPost?: SearchItemType;
  contents?: {
    fileName: string;
    fileSize: number;
    contentType: string;
    dsc: string;
    pageCount: number;
    uri: string;
    cExtensionStr: string;
    objId: number;
    fileIdView: string;
    metadataFileId: string;
  }[];
  highlightsMap?: {
    annotation: string[];
    ['content.body']: string[];
    title?: string[];
    dsc?: string[];
  };
  searchForm?: SearchFiltersType;
};

export type SearchPeopleItem = SearchItemBase & {
  typeId: SearchItemTypeEnum.people;
  entityInfo: SearchItemEntityInfo;
};

export type SearchContentItem = SearchItemBase & {
  typeId?: Exclude<SearchItemTypeEnum, SearchItemTypeEnum.people>;
  entityInfo?: never;
};

export type SearchItemType = SearchPeopleItem | SearchContentItem;

export type SearchItemPostData = {
  authors?: unknown[];
  document?: string;
};

export type SearchFiltersType = {
  startYear: string | null;
  endYear: string | null;
  keywords?: string;
  author?: string;
  size?: string;
  startPublicationDate: string | null;
  endPublicationDate: string | null;
  topics?: string;
  section?: SectionEnum;
  excludeRepost?: boolean;
  workplace?: string;
  city?: string;
  cCity?: CityType | null;
  gender?: string;
};

// TODO NauSearchActionPayload

export type SearchRequestType = {
  message: string;
  filters?: SearchFiltersType;
  pageSize?: number;
  isAddLoad?: boolean;
  typeId?: SearchItemTypeEnum;
};

export type SearchRequestResultType = {
  data: SearchItemPostData[] | null;
  searchAfterIdSort: string;
  searchAfterScore: number;
  hasNextPage: boolean;
  isAddLoad?: boolean;
  totalElements: number;
};

export type SearchStoreType = {
  error: boolean;
  errorText: string;
  loading: boolean;
  hasNextPage: boolean;
  postData: SearchItemPostData;
  searchResult: SearchItemType[];
  searchItem: SearchItemType | null;
  searchQueryMessage: string;
  searchAfterIdSort?: string | null;
  searchAfterScore?: number | null;
  pageNumber?: number;
  totalElements: number;
  searchForm: SearchFiltersType;
};
